// src/context/DictionaryContext.js
import { createContext, useContext } from 'react';
import { getVocabulary } from '../data/vocabularies/index';

export const DictionaryContext = createContext({});
export const useDictionary = () => useContext(DictionaryContext);

export function DictionaryProvider({ moduleId, children }) {
  const dictionary = getVocabulary(moduleId?.toUpperCase());
  
  // ✅ Sin "key" — solo lo que existe:
  console.log('🔑 Provider moduleId:', moduleId, '→ keys:', Object.keys(dictionary).length);
  
  return (
    <DictionaryContext.Provider value={dictionary}>
      {children}
    </DictionaryContext.Provider>
  );
}
